import { useState } from "react";
import "flexlayout-react/style/light.css";
import { Grid2 } from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import '../Orders.css'
import DepositHistory from "./DepositHistory";
import WithdrawHistory from "./WithdrawHistory";
import { useSearchParams } from 'react-router-dom';
import { a11yProps, CustomTabPanel } from "../../common/CustomTabs";
import InvestmentHistory from "./InvestmentHistory";

function TransactionHistory() {

    const [searchParams, setSearchParams] = useSearchParams();
    const initialTab = parseInt(searchParams.get("tab")) || 0;
    const [value2, setValue2] = useState(initialTab);

    const updateParams = (updates) => {
        setSearchParams((prev) => {
            const params = new URLSearchParams(prev);
            Object.entries(updates).forEach(([key, value]) => {
                if (value === "" || value === null || value === undefined) {
                    params.delete(key);
                } else {
                    params.set(key, value);
                }
            });
            return params;
        });
    };


    const handleTabChange = (event, newValue) => {
        setValue2(newValue);
        updateParams({ tab: newValue, page: '' });
    };

    return (
        <div className="p-4 space-x-2">
            <Grid2 container sx={{ justifyContent: 'center' }}>
                <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <div className="display-2 mb-20" >
                        <h2 className="gold-color">Transaction History</h2>
                    </div>
                    <Grid2 container sx={{ justifyContent: 'center' }} >
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <div style={{ margin: "5px" }}>
                                <Box className="display-2 ads-tab tab-cmn">
                                    <Tabs value={value2} onChange={handleTabChange} variant="scrollable"
                                        className="no-drag"
                                        scrollButtons
                                        allowScrollButtonsMobile
                                        aria-label="scrollable force tabs example" sx={{ minHeight: '30px' }}>
                                        <Tab sx={{ fontSize: '16px' }} label="Deposit" {...a11yProps(0)} />
                                        <Tab sx={{ fontSize: '16px' }} label="Withdraw" {...a11yProps(1)} />
                                        <Tab sx={{ fontSize: '16px' }} label="Investment" {...a11yProps(2)} />
                                    </Tabs>
                                </Box>
                                <Box>
                                </Box>
                                <CustomTabPanel value={value2} index={0} className="futures-trade-table">
                                    <DepositHistory />
                                </CustomTabPanel>
                                <CustomTabPanel value={value2} index={1} className="futures-trade-table">
                                    <WithdrawHistory />
                                </CustomTabPanel>
                                <CustomTabPanel value={value2} index={2} className="futures-trade-table">
                                    <InvestmentHistory />
                                </CustomTabPanel>
                            </div>
                        </Grid2>
                    </Grid2>
                </Grid2>


            </Grid2>


        </div>
    );
}

export default TransactionHistory;
